module.exports = __webpack_public_path__ + "static/media/bharat.a8b6fd9d.webp";